// removed by extract-text-webpack-plugin
module.exports = {"summaryOuter":"zmvFTqPC2tvIQ80xMfThq_0","summaryHeadline":"_1vHMcbM-uGLT2vuH_yg3VM_0","summaryContent":"fEpGM4YJsi_e5whrqOuwu_0"};


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/prod-isrs-frontend-mb_master/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"autoprefixer":false,"localIdentName":"[hash:base64]_0","importLoaders":1,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-44b3e854","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/components/CbrSummary.vue
// module id = 155
// module chunks = 0